export default {
    label: 'Copy',
    successMessage: 'Copied to clipboard!',
};
